export const stockTradingCourse = {
  module: 1, // one-module course, starts at 1
  titleKey: "stockTradingBasicsTitle",
  lessons: [
    { id: 1, titleKey: "stockTradingIntro", videoByLang: { pt: "lDYMcV8-QbA", en: null },},
    { id: 2, titleKey: "basicTerminology", videoByLang: { pt: "9_Lttn8Ml5I", en: null },},
    { id: 3, titleKey: "orderTypes", videoByLang: { pt: "7ztVaK9fKTc", en: null },},
    { id: 4, titleKey: "tradingStrategies", videoByLang: { pt: "IggPbUvWsXA", en: null },},
    { id: 5, titleKey: "riskManagementBasics", videoByLang: { pt: "phplY-2y7is", en: null },},
    { id: 6, titleKey: "beyondBorders", videoByLang: { pt: "dMYWZ7Mdv7E", en: null },},
  ],
};


// src/CourseData.js (language-agnostic)

export const personalFinanceCourses = [
  {
    module: 0,
    lessons: [
      { id: 1, globalId: 1, titleKey: "whyPersonalFinance", 
        //videoByLang: { pt: "9chKHrw3Yfw", en: null } 
        },
      { id: 2, globalId: 2, titleKey: "knowRiskLimit" },
      { id: 3, globalId: 3, titleKey: "investments" },
    ],
  },
  {
    module: 1,
    lessons: [
      { id: 1,  globalId: 4,  titleKey: "waysInvest" },
      { id: 2,  globalId: 5,  titleKey: "differentStockThinking" },
      { id: 3,  globalId: 6,  titleKey: "buyingSellingStocks" },
      { id: 4,  globalId: 7,  titleKey: "marketTimingExamples" },
      { id: 5,  globalId: 8,  titleKey: "sellingStocks" },
      { id: 6,  globalId: 9,  titleKey: "stocksHaveHomes1" },
      { id: 7,  globalId: 10, titleKey: "stocksHaveHomes2" },
      { id: 8,  globalId: 11, titleKey: "whereToFindStocks" },
      { id: 9,  globalId: 12, titleKey: "priceDiscovery" },
      { id: 10, globalId: 13, titleKey: "mutualFunds" },
      { id: 11, globalId: 14, titleKey: "vanguardGrowth" },
      { id: 12, globalId: 15, titleKey: "vanguard500" },
    ],
  },
  {
    module: 2,
    lessons: [
      { id: 1,  globalId: 16, titleKey: "financialRatios" },
      { id: 2,  globalId: 17, titleKey: "etfs" },
      { id: 3,  globalId: 18, titleKey: "stockIndices" },
      { id: 4,  globalId: 19, titleKey: "stockAnalysis" },
      { id: 5,  globalId: 20, titleKey: "bonds" },
      { id: 6,  globalId: 21, titleKey: "bondPricing" },
      { id: 7,  globalId: 22, titleKey: "bondEarnings" },
      { id: 8,  globalId: 23, titleKey: "stockInstruments" },
      { id: 9,  globalId: 24, titleKey: "marginShortSelling" },
      { id: 10, globalId: 25, titleKey: "options1" },
      { id: 11, globalId: 26, titleKey: "options2" },
    ],
  },
  {
    module: 3,
    lessons: [
      { id: 1,  globalId: 27, titleKey: "insuranceDefensiveStrategy" },
      { id: 2,  globalId: 28, titleKey: "insuranceVsSpeculation" },
      { id: 3,  globalId: 29, titleKey: "oddsMakerUnderwriting" },
      { id: 4,  globalId: 30, titleKey: "insuranceEconomics" },
      { id: 5,  globalId: 31, titleKey: "termInsurance" },
      { id: 6,  globalId: 32, titleKey: "universalLife" },
      { id: 7,  globalId: 33, titleKey: "needInsurance" },
      { id: 8,  globalId: 34, titleKey: "miscellaneousInsurance" },
      { id: 9,  globalId: 35, titleKey: "viaticalInsurance" },
      { id: 10, globalId: 36, titleKey: "propertyInsurance" },
      { id: 11, globalId: 37, titleKey: "homeownerInsurance" },
      { id: 12, globalId: 38, titleKey: "automobileInsurance" },
      { id: 13, globalId: 39, titleKey: "autoInsuranceClaims" },
      { id: 14, globalId: 40, titleKey: "autoInsurancePremiums" },
      { id: 15, globalId: 41, titleKey: "decreasePremium" },
      { id: 16, globalId: 42, titleKey: "intuitionInsuranceResearch" },
    ],
  },
  {
    module: 4,
    lessons: [
      { id: 1,  globalId: 43, titleKey: "roleOfCredit" },
      { id: 2,  globalId: 44, titleKey: "differentFacesOfCredit" },
      { id: 3,  globalId: 45, titleKey: "creditHouseholdDebtParadox" },
      { id: 4,  globalId: 46, titleKey: "isAllCreditEqual" },
      { id: 5,  globalId: 47, titleKey: "deadbeatsVsRevolvers" },
      { id: 6,  globalId: 48, titleKey: "whatLendersLookFor" },
      { id: 7,  globalId: 49, titleKey: "creditBureaus" },
      { id: 8,  globalId: 50, titleKey: "creditBureauInformation" },
      { id: 9,  globalId: 51, titleKey: "ficoScore" },
      { id: 10, globalId: 52, titleKey: "creditReportGuts" },
      { id: 11, globalId: 53, titleKey: "bankruptcy" },
      { id: 12, globalId: 54, titleKey: "creditRationing" },
    ],
  },
  {
    module: 5,
    lessons: [
      { id: 1,  globalId: 55, titleKey: "startEarlyRetirement" },
      { id: 2,  globalId: 56, titleKey: "threeLeggedStool" },
      { id: 3,  globalId: 57, titleKey: "socialSecurity" },
      { id: 4,  globalId: 58, titleKey: "historyOfSocialSecurity" },
      { id: 5,  globalId: 59, titleKey: "socialSecurityReserves" },
      { id: 6,  globalId: 60, titleKey: "pensions" },
      { id: 7,  globalId: 61, titleKey: "definedContributions" },
      { id: 8,  globalId: 62, titleKey: "chooseRetirementPlan" },
      { id: 9,  globalId: 63, titleKey: "vesting" },
      { id: 10, globalId: 64, titleKey: "retirementBehaviorResearch" },
      { id: 11, globalId: 65, titleKey: "lastLegRetirement" },
      { id: 12, globalId: 66, titleKey: "rothIRA" },
      { id: 13, globalId: 67, titleKey: "traditionalVsRoth" },
      { id: 14, globalId: 68, titleKey: "improvingRetirementSavingsBehavior" },
      { id: 15, globalId: 69, titleKey: "conclusion" },
    ],
  },
];

export const InvestparaBr = [
  {
    module: 0,
    titleKey: "mod0_orientacao",
    lessons: [
      { id: 1, titleKey: "boas_vindas_e_como_funciona", videoByLang: { pt: "vRQ7nJJCTu0", en: null }, },
      { id: 2, titleKey: "Entendendo_o_cenario_de_investimentos", videoByLang: { pt: "4Lwj1PGNm6I", en: null },  }
    ]
  },
  {
    module: 1,
    titleKey: "mod1_accounts101_brokerage_vs_retirement",
    lessons: [
      { id: 1, titleKey: "conta_brokerage_pros_contras_quando_usar", videoByLang: { pt: "MTxhSUS1kAs", en: null }, },
      { id: 2, titleKey: "visao_geral_contas_aposentadoria_401k_trad_roth", videoByLang: { pt: "EOfW1et5tZY", en: null }, },
      { id: 3, titleKey: "elegibilidade_ssn_versus_itin_emprego_limites_match" , videoByLang: { pt: "8w_FfCugP4M", en:null},},
      { id: 4, titleKey: "rollovers_old_401k_para_ira", videoByLang: { pt: "6Pk6DEAMnvM", en:null},}, 
    ]
  },
  {
    module: 2,
    titleKey: "mod2_impostos_eua_para_investidores_simplificado",
    lessons: [
      { id: 1, titleKey: "o_que_e_tributado_ganhos_dividendos_juros", videoByLang: { pt: "eBABdWp0dao", en:null},},
      { id: 2, titleKey: "custo_base_fifo_id_especifico_tax_loss_harvesting", videoByLang: { pt: "BdziYCfXEC0", en:null},},
      { id: 3, titleKey: "como_contas_aposentadoria_mudam_tributacao", videoByLang: { pt: "0NxFJLrH0ZU", en:null},},
      { id: 4, titleKey: "declaracao_basica_imigrantes_residente_nao_residente_w9_w8ben_fbar_fatca", videoByLang: { pt: "4Sj8IPOqpI8", en:null},},
    ]
  },
  {
    module: 3,
    titleKey: "mod3_instrumentos_principais_etfs_reits_bonds",
    lessons: [
      { id: 1, titleKey: "etfs_funcionamento_tracking_custos_liquidez", videoByLang: { pt: "FBAZvSmYnDg", en:null},},
      { id: 2, titleKey: "reits_equity_vs_mortgage_dividendos_juros", videoByLang: { pt: "g3XOif6tb3Y", en:null},},
      { id: 3, titleKey: "bonds_treasuries_corporates_etfs_duration_credito_ladders_vs_fundos", videoByLang: { pt: "FwsMMh_5pwE", en:null},},
      { id: 4, titleKey: "portfolio_core_e_satellite", videoByLang: { pt: "RNpm2AYM1dM", en:null},},
    ]
  },
  {
    module: 4,
    titleKey: "mod4_construcao_de_portfolio_e_automacao",
    lessons: [
      { id: 1, titleKey: "alocacao_por_objetivo_tempo_fundo_emergencia_primeiro", videoByLang: { pt: "I2Hf5fDtc-I", en:null},},
      { id: 2, titleKey: "dca_auto_invest_rebalanceamento", videoByLang: { pt: "pWBCj7T4b_4", en:null},},
      { id: 3, titleKey: "controles_de_risco_concentracao_home_bias_moeda_usd_vs_brl", videoByLang: { pt: "F6hF-WYWTok", en:null}, },
      { id: 4, titleKey: "fundos_target_date_vs_build_your_own", videoByLang: { pt: "Qs-2kFSt7Rc", en:null}, }, 
    ]
  },
  {
    module: 5,
    titleKey: "mod5_planos_de_aposentadoria_approfundado",
    lessons: [
      { id: 1, titleKey: "401k_match_vesting_roth_401k_opcoes_no_plano", videoByLang: { pt: "sFQ0w8lVrc8", en:null}, },
      { id: 2, titleKey: "iras_traditional_vs_roth_backdoor_roth_conceitual_janelas", videoByLang: { pt: "A80eiQXWy_A", en:null}, },
      { id: 3, titleKey: "autonomos_solo_401k_e_sep_ira_visao_geral", videoByLang: { pt: "IU9Fm_Y5Zeo", en:null}, },
    ]
  },
  {
    module: 6,
    titleKey: "mod6_erros_golpes_e_cross_border",
    lessons: [
      { id: 1, titleKey: "erros_comuns_brasileiros_eua_pular_emergencia_ignorar_match_focar_acoes_puro_panico_misturar_objetivos", videoByLang: { pt: "gADcjjBFNBc", en:null}, },
      { id: 2, titleKey: "scams_e_falsos_gurus_promessas_milagrosas_pump_and_dump_como_se_proteger", videoByLang: { pt: "tTPaP8rxya0", en:null}, },
      { id: 3, titleKey: "cross_border_basics_brasil_pfic_fbar_fatca", videoByLang: { pt: "1q4vDZ0H3DI", en:null}, },
      { id: 4, titleKey: "capstone_plano_de_investimento_90_dias" },
      { id: 5, titleKey: "capstone"},
   
    ]
  }
];
